/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlayerNoteDtoListResult } from '../../models/player-note-dto-list-result';

export interface ApiPlayerNotesPlayerPlayerIdGet$JsonOdataStreamingFalse$Params {
  playerId: number;
  PlayerId?: number;
  OnlyMyNotes?: boolean;
}

export function apiPlayerNotesPlayerPlayerIdGet$JsonOdataStreamingFalse(http: HttpClient, rootUrl: string, params: ApiPlayerNotesPlayerPlayerIdGet$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerNoteDtoListResult>> {
  const rb = new RequestBuilder(rootUrl, apiPlayerNotesPlayerPlayerIdGet$JsonOdataStreamingFalse.PATH, 'get');
  if (params) {
    rb.path('playerId', params.playerId, {});
    rb.query('PlayerId', params.PlayerId, {});
    rb.query('OnlyMyNotes', params.OnlyMyNotes, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json;odata.streaming=false', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlayerNoteDtoListResult>;
    })
  );
}

apiPlayerNotesPlayerPlayerIdGet$JsonOdataStreamingFalse.PATH = '/api/player-notes/player/{playerId}';
